export const PAYMENT_FORMS = [
    'À vista',
    'A prazo'
    // 'Apresentação'
];